import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TrackerAuthContext = createContext(null);

export const useTrackerAuth = () => useContext(TrackerAuthContext);

export const TrackerAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("tracker_token");
    const stored = localStorage.getItem("tracker_user");
    if (token && stored) {
      try {
        setUser(JSON.parse(stored));
      } catch {
        localStorage.removeItem("tracker_token");
        localStorage.removeItem("tracker_user");
      }
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    const res = await axios.post(`${API}/tracker/auth/login`, { email, password });
    const { token, display_name } = res.data;
    const u = { email, display_name, token };
    localStorage.setItem("tracker_token", token);
    localStorage.setItem("tracker_user", JSON.stringify(u));
    setUser(u);
    return u;
  };

  const logout = () => {
    localStorage.removeItem("tracker_token");
    localStorage.removeItem("tracker_user");
    setUser(null);
  };

  const getAuthHeaders = () => {
    const token = localStorage.getItem("tracker_token");
    return token ? { Authorization: `Bearer ${token}` } : {};
  };

  return (
    <TrackerAuthContext.Provider value={{ user, login, logout, loading, getAuthHeaders }}>
      {children}
    </TrackerAuthContext.Provider>
  );
};
